// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"284838efa5867135890a","655":"65a872cdcbe1142f5cea"}[chunkId] + ".js";
};